<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        :breadcrumbs="[{ name: '各種設定' }]"
        title="閲覧制限用IPアドレス設定"
      />
      <div class="grid-x align-justify">
        <div class="medium-9 cell">
          <p>この企業様管理画面の閲覧を許可するIPアドレスの設定を行います。</p>
          <p>
            ※IPアドレスは３０個まで登録できます。
          </p>
        </div>
        <div class="medium-3 cell">
          <div class="float-right">
            <span
              v-tooltip="{ content: isOverLengthIpAddresses() ? 'IPアドレスは30件までしか登録できません。' : '' }"
              :disabled="isOverLengthIpAddresses()"
              class="boss-button pega-button boss-button-new"
              data-test="add-ip-address-button"
              @click="addIpAddress()"
            >
              <span class="boss-icon-new" />
              <span class="boss-button-new-text">IPアドレスを追加</span>
            </span>
          </div>
        </div>
      </div>
      <form-item
        v-for="(_, index) in ipAddresses"
        :key="index"
        v-model="ipAddresses[index]"
        maxlength="15"
        :label="(index + 1) | label"
        :data-test="`ip-address-form-${index}`"
        :class-name="!isIpAddressFormat(ipAddresses[index]) ? 'pega-width-auto is-invalid-input': 'pega-width-auto'"
      >
        <template #header>
          <small>※半角15文字以内</small>
        </template>
        <template #error>
          <validation-label
            v-if="!isIpAddressFormat(ipAddresses[index])"
            :label="`IPアドレスの形式に沿って入力してください。\n（例）198.51.100.0`"
            :data-test="`invalid-ip-address-${index}`"
          />
        </template>
      </form-item>
      <form-button-area>
        <form-confirm-button
          :is-disabled="isDisabledRegisterButton"
          submit-label="設定する"
          data-test="confirm-button"
          @submit-event="registerIpAddresses"
        />
      </form-button-area>
    </div>
  </div>
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import FormItem from '@/components/atoms/FormItem'
import ValidationLabel from '@/components/atoms/ValidationLabel'
import FormButtonArea from '@/components/atoms/FormButtonArea'
import FormConfirmButton from '@/components/atoms/FormConfirmButton'
import _ from 'lodash'
import util from '@/lib/util.js'

export default {
  filters: {
    label (index) {
      return `IPアドレス[${index}]`
    }
  },
  components: {
    SettingHeader,
    FormItem,
    ValidationLabel,
    FormButtonArea,
    FormConfirmButton
  },
  data () {
    return {
      ipAddresses: []
    }
  },
  computed: {
    requestParam () {
      return this.ipAddresses.filter(ipAddress => !_.isEmpty(ipAddress))
    },
    isIpAddressFormat () {
      return (val) => {
        return _.isEmpty(val) || util.isIpAddressFormat(val)
      }
    },
    isDisabledRegisterButton () {
      return this.ipAddressesInvalid()
    }
  },
  created () {
    this.fetchIpAddresses()
  },
  methods: {
    fetchIpAddresses () {
      this.$http.secured.get('/admin/settings/allowed_ip').then(response => {
        this.$set(this, 'ipAddresses', response.data)
        this.addIpAddress()
      })
    },
    addIpAddress () {
      if (this.isOverLengthIpAddresses()) {
        return
      }
      this.ipAddresses.push('')
    },
    registerIpAddresses () {
      this.$http.secured.post('/admin/settings/allowed_ip', this.requestParam).then(response => {
        this.$toasted.global.success({ message: '閲覧制限を設定しました。' })
        this.$router.push({ name: 'dashboardTop' })
      })
    },
    isOverLengthIpAddresses () {
      return this.ipAddresses.length >= 30
    },
    ipAddressesInvalid () {
      return !!(_.find(this.requestParam, ipAddress => !this.isIpAddressFormat(ipAddress)))
    }
  }
}
</script>
